import { useCallback } from "react";

export function useTextToSpeech() {
  const speakTranslation = useCallback((text: string, langCode: string, force = false, voiceEnabled = false) => {
    if (!voiceEnabled && !force) return;
    if (!window.speechSynthesis) return;

    const utterance = new SpeechSynthesisUtterance(text);
    const langMap: Record<string, string> = { es: "es-ES", en: "en-US" };
    utterance.lang = langMap[langCode] || langCode;

    const voices = window.speechSynthesis.getVoices();
    const maleKeywords = ["raul", "pablo", "david", "mark", "george", "julio", "jorge", "alex", "daniel", "male"];

    const voice = voices.find(
      (v) =>
        v.lang.startsWith(utterance.lang) &&
        maleKeywords.some((k) => v.name.toLowerCase().includes(k))
    );

    if (voice) {
      utterance.voice = voice;
      utterance.pitch = 0.9;
      utterance.rate = 1.0;
    } else {
      const fallback = voices.find((v) => v.lang.startsWith(utterance.lang));
      if (fallback) utterance.voice = fallback;
    }

    if (force) {
      window.speechSynthesis.cancel();
      window.speechSynthesis.speak(utterance);
      return;
    }

    if (!window.speechSynthesis.speaking) {
      window.speechSynthesis.speak(utterance);
    } else {
      setTimeout(() => {
        window.speechSynthesis.speak(utterance);
      }, 500);
    }
  }, []);

  return { speakTranslation };
}
